<template>
  <div class="page-container" style="min-height: auto;">
    <Loading ref="loading" />

    <div class="page-title-container">
      <h1 class="title-text">Dashboard</h1>
    </div>

    <div class="dashboard-container">
      <div class="dashboard-plan-name-container">
        <a @click="logout()">
          Log out
        </a>
      </div>

      <div class="dashboard-actions-container">
        <div class="dashboard-actions-left-container">
          <button @click="$router.push({ path: '/pricing' })" class="secondary-button small-button" type="button">
            Reach more candidates! 🔥
          </button>
        </div>
      </div>

      <div class="dashboard-actions-container">
        <div class="dashboard-actions-left-container">
          <!--
          <div class="dashboard-panel-container">
              <p class="dashboard-text-counter">You posted <span style="color: var(--primary-color);">{{subscription.jobsPosted}} / {{subscription.totalPostsThisPeriod}}</span> job offers this month 🎉</p>
          </div>
          -->

          <div class="dashboard-panel-container">
            <p class="dashboard-text-counter">
              You have
              <span style="color: var(--primary-color);">{{ subscription.purchasedJobPosts }}</span>
              job offers to post 🎉
            </p>
          </div>

          <button @click="$router.push({ path: '/post-job' })" class="primary-button medium-button" type="button">
            Post job
          </button>
        </div>

        <div class="dashboard-actions-right-container">
          <button @click="$router.push({ path: '/suggest-site' })" class="tertiary-button medium-button" type="button">
            Suggest site
          </button>
          <div>
            <button
              v-if="$store.state.auth.isAdmin"
              @click="$router.push({ path: '/admin' })"
              class="secondary-button medium-button"
              style="margin-left: 0.5rem;"
              type="button"
            >
              Admin
            </button>
          </div>
        </div>
      </div>

      <p style="font-size: 0.8rem; margin-bottom: 0rem;">Your User ID: {{ $store.state.auth.user.uid }}</p>
      <p
        v-if="subscription.userPlans.length !== 0"
        @click="$router.push({ path: '/invoices' })"
        style="font-size: 0.8rem; text-decoration: underline; cursor: pointer;"
      >
        Invoices
      </p>
    </div>

    <div class="page-title-container">
      <h2 class="subtitle-text">STATUS OF YOUR JOB POSTS</h2>
    </div>

    <div class="dashboard-status-container">
      <div v-if="posts.length === 0" class="dashboard-panel-status" style="margin-bottom: 15rem; justify-content: center;">
        <p>
          You haven’t post any job offer yet. Click
          <a @click="$router.push({ path: '/post-job' })">here</a> to post your job offers. 🚀
        </p>
      </div>

      <div :key="i" v-for="(p, i) in paginatedPosts" class="dashboard-panel-status">
        <p v-if="p.state === 'pending'" class="dashboard-text-counter">
          🕓 Pending:
          <span style="color: var(--primary-color);">{{ p.pedingCount }}</span>
          sites
        </p>
        <p v-if="p.state === 'completed'" class="dashboard-text-counter">
          ✅ Sent to
          <span style="color: var(--primary-color);">{{ p.completedCount }}</span>
          sites
        </p>
        <p>{{ p.jobTitle }}</p>
        {{ p.completedLink }}
        <time class="article-preview-date">{{ p.createdAt.toDate().toDateString() }} {{ p.createdAt.toDate().toLocaleTimeString() }}</time>
        <button @click="$router.push({ path: `/job-offer/${p.id}` })" class="secondary-button small-button" type="button">
          See details
        </button>
      </div>
    </div>
  </div>

  <div class="pagination-container">
    <button v-if="currentPage !== 0" @click="previous()" class="secondary-button small-button pagination-button">
      <i class="fas fa-arrow-left previous-page-button-icon"></i> Previous
    </button>
    <button v-if="m()" @click="next()" class="secondary-button small-button">
      Next <i class="fas fa-arrow-right next-page-button-icon"></i>
    </button>
  </div>
</template>

<script>
import firebase from "@/firebase";
import Loading from "@/components/Loading";

export default {
  components: {
    Loading,
  },

  data() {
    return {
      subscription: {
        purchasedJobPosts: 0,
        jobsPosted: 0,
        remainingPosts: 0,
        totalPostsThisPeriod: 0,
        activeUserPlans: [],
        userPlans: [],
      },
      posts: [],
      currentPage: 0,
      itemsPerPage: 10,
    };
  },

  computed: {
    paginatedPosts() {
      return this.posts.slice(this.currentPage * this.itemsPerPage, this.currentPage * this.itemsPerPage + this.itemsPerPage);
    },
  },

  mounted() {
    this.$refs.loading.open();
  },

  created() {
    window.scrollTo(0, 0);
    firebase.functions
      .httpsCallable("getSubscriptionState")()
      .then((r) => {
        this.$refs.loading.close();
        this.subscription = r.data;
      })
      .catch((e) => console.error(e));

    this.getjobs();
  },

  methods: {
    sendInvoices() {
      const Paddle = window.Paddle;
      Paddle.User.History(this.$store.state.auth.user.email, null, (response) => {
        if (response.success) {
          // Let the user know they'll receive an email with their
          // order history and license codes if their email was matched.
        } else {
          // Likely a formatting error in the email, vendorID, or ProductID.
        }
      });
    },

    getjobs() {
      firebase.functions
        .httpsCallable("getAllJobsByUserId")()
        .then((snapshot) => {
          for (const post of snapshot.data) {
            const t = new firebase.Timestamp(post.createdAt._seconds, post.createdAt._nanoseconds);
            post.createdAt = t;
            this.posts.push(post);
          }
        })
        .catch((error) => {
          console.error("Error getting documents: ", error);
        });
    },

    m() {
      const maxPages = Math.trunc(this.posts.length / this.itemsPerPage);
      return this.currentPage + 1 < maxPages;
    },

    next() {
      this.currentPage++;
      window.scrollTo(0, 0);
    },
    previous() {
      this.currentPage--;
      window.scrollTo(0, 0);
    },
    logout() {
      firebase.auth
        .signOut()
        .then(() => {
          this.$router.push({ path: "/" });
          localStorage.clear();
        })
        .catch((error) => {
          console.error(error);
          this.$router.push({ path: "/" });
        });
    },
  },
};
</script>

<style>
.big-logo {
  max-width: 600px;
  max-height: 600px;
}
</style>
